// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('timeRegisterNewJobSelectOp', {
//         templateUrl: 'views/components/views/trNewJobSelectOp/trNewJobSelectOp.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'trNewJobSelectOpService', function ($stateParams, utilityService, trNewJobSelectOpService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let labourNo = $stateParams.labour_no;
            
//             vm.model = {
//                 bgOperationTrListSelection: {
//                     selected: '0',
//                     buttons: [
//                         { id: '0', label: 'operation_direct', color: 'primary', onClick: () => vm.model.bgOperationTrListSelection.selected = '0' },
//                         { id: '1', label: 'operation_indirect', color: 'primary', onClick: () => vm.model.bgOperationTrListSelection.selected = '1' }
//                     ]
//                 },
//                 itemsListOperations: []
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALL

//             async function loadOperations() {
//                 if (utilityService.validateParmsValue(vm.model.bgOperationTrListSelection.selected) !== true) return;

//                 vm.model.itemsListOperations = await trNewJobSelectOpService.listOperationTrs({
//                     labour_no: labourNo,
//                     direct: vm.model.bgOperationTrListSelection.selected
//                 });
//             }

//             // #region LOAD PROCEDURE FUNCTION CALL

//             // #region BUTTON RADIO FUNCTIONS

//             vm.selectBgOperationTrListSelection = function (value) {
//                 vm.model.bgOperationTrListSelection.selected = value;

//                 loadOperations();
//             }

//             // #endregion BUTTON RADIO FUNCTIONS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 loadOperations();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
